import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Table } from "reactstrap";
import PageLayout from "../PageLayout";
import { joinedAllJournalsApi, leaveJournalApi } from "src/network/api";

const JoinedReviewersList = () => {
  const [joinedReviewers, setJoinedReviewers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchJoinedReviewers = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await joinedAllJournalsApi();
      if (response?.data?.status === 200) {
        setJoinedReviewers(response.data.data || []);
      } else {
        setError(response?.data?.message || "Failed to fetch data.");
      }
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJoinedReviewers();
  }, []);

  // Function to leave a journal
  const handleLeaveJournal = async (requestId) => {
    if (!requestId) {
      alert("Invalid request. Please try again.");
      return;
    }

    if (!window.confirm("Are you sure you want to leave this journal?")) return;

    setLoading(true);
    setError("");

    try {
      const response = await leaveJournalApi(requestId);

      if (response?.data?.status === 200) {
        alert("Journal successfully removed.");
        setJoinedReviewers((prevReviewers) =>
          prevReviewers.filter((journal) => journal.request_id !== requestId)
        );
      } else {
        throw new Error(response?.data?.message || "Failed to remove journal.");
      }
    } catch (error) {
      console.error("Error removing journal:", error);

      if (
        error?.response?.status === 400 &&
        error?.response?.data?.message === "Joined Link not found"
      ) {
        alert("This journal may have already been removed or does not exist.");
      } else {
        alert(error.message || "An unexpected error occurred.");
      }

      setError("Error removing the journal. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout>
      <div className="table-container mt-2 mb-2" style={{ padding: "10px" }}>
        <Card className="shadow-lg">
          <CardHeader className="bg-primary">
            <h3 className="mb-0 text-center font-weight-bold text-white">
              Joined Reviewers
            </h3>
          </CardHeader>
          <CardBody>
            {loading ? (
              <p className="text-center text-primary">Loading...</p>
            ) : error ? (
              <p className="text-center text-danger">{error}</p>
            ) : (
              <div style={{ overflowX: "auto", width: "100%" }}>
                <Table
                  bordered
                  hover
                  responsive
                  className="table-sm mb-0 text-center"
                >
                  <thead className="thead-light">
                    <tr>
                      <th>Journal ID</th>
                      <th>Request ID</th>
                      <th>Journal Name</th>
                      <th>Reviewer Name</th>
                      <th>Email</th>
                      <th>Contact</th>
                      <th>Department</th>
                      <th>Designation </th>
                      <th>Qualification </th>
                      <th>Country</th>
                      <th>State</th>
                      <th>Research Area</th>
                      <th>Joining Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {joinedReviewers.length > 0 ? (
                      joinedReviewers.map((journal, index) => (
                        <tr key={index}>
                          <td>{journal.journal_id}</td>
                          <td>{journal.request_id}</td>
                          <td>{journal.journal_name}</td>
                          <td>{journal.name || "N/A"}</td>
                          <td>{journal.email || "N/A"}</td>
                          <td>{journal.contact}</td>
                          <td>{journal.department}</td>
                          <td>{journal.designation}</td>
                          <td>{journal.maximum_qualification}</td>
                          <td>{journal.country_name}</td>
                          <td>{journal.state_name}</td>
                          <td>{journal.research_area}</td>

                          <td>{journal.created_at}</td>
                          <td>
                            <Button
                              className="mt-2 mb-2"
                              color="danger"
                              size="sm"
                              onClick={() =>
                                handleLeaveJournal(journal.request_id)
                              }
                            >
                              Remove
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={14} className="text-center text-muted">
                          No Reviewers found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    </PageLayout>
  );
};

export default JoinedReviewersList;
